import React from 'react';
import { Truck, RotateCcw, Package, Recycle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLang } from '../contexts/LanguageContext';

export default function SpedizioniResiPage() {
  const { t } = useLang();

  return (
    <div data-testid="spedizioni-page" className="min-h-screen bg-[#FAF9F6] pt-24 pb-24">
      <section className="px-6 md:px-12 lg:px-24 py-16">
        <div className="max-w-4xl">
          <p className="overline mb-4">{t({ it: 'Assistenza', en: 'Customer Care' })}</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#1C1917] mb-16">
            {t({ it: 'Spedizioni e Resi', en: 'Shipping & Returns' })}
          </h1>

          <div className="space-y-12">
            <div className="bg-white border border-[#E5E0D8] p-8">
              <div className="flex items-center gap-3 mb-4">
                <Truck className="w-6 h-6 text-[#4A5D23]" />
                <h2 className="text-lg font-medium text-[#1C1917]">{t({ it: 'Spedizioni', en: 'Shipping' })}</h2>
              </div>
              <ul className="space-y-3 text-sm text-[#1C1917]/70 leading-relaxed">
                <li>• {t({
                  it: 'Italia: spedizione standard gratuita per ordini superiori a €300, altrimenti €6,90. Consegna in 2-4 giorni lavorativi.',
                  en: 'Italy: free standard shipping on orders over €300, otherwise €6.90. Delivery in 2-4 working days.',
                })}</li>
                <li>• {t({
                  it: 'Europa: spedizione €12,90. Consegna in 4-7 giorni lavorativi.',
                  en: 'Europe: shipping €12.90. Delivery in 4-7 working days.',
                })}</li>
                <li>• {t({
                  it: 'Tutti gli ordini vengono spediti con imballaggi riciclabili e plastic-free.',
                  en: 'All orders are shipped in recyclable, plastic-free packaging.',
                })}</li>
                <li>• {t({
                  it: "Riceverai un'email con il codice di tracciamento non appena l'ordine sarà affidato al corriere.",
                  en: 'You will receive an email with the tracking code as soon as your order is handed to the courier.',
                })}</li>
              </ul>
            </div>

            <div className="bg-white border border-[#E5E0D8] p-8">
              <div className="flex items-center gap-3 mb-4">
                <RotateCcw className="w-6 h-6 text-[#4A5D23]" />
                <h2 className="text-lg font-medium text-[#1C1917]">{t({ it: 'Resi e Rimborsi', en: 'Returns & Refunds' })}</h2>
              </div>
              <ul className="space-y-3 text-sm text-[#1C1917]/70 leading-relaxed">
                <li>• {t({
                  it: 'Hai 14 giorni dalla consegna per restituire un capo non indossato, con etichette originali.',
                  en: 'You have 14 days from delivery to return an unworn garment with original tags.',
                })}</li>
                <li>• {t({
                  it: "Il reso è gratuito: contattaci a info@biolosophy.it per ricevere l'etichetta di reso prepagata.",
                  en: 'Returns are free: contact us at info@biolosophy.it to receive a prepaid return label.',
                })}</li>
                <li>• {t({
                  it: 'Il rimborso viene emesso sul metodo di pagamento originale entro 5-10 giorni lavorativi dal ricevimento del reso.',
                  en: 'Refunds are issued to the original payment method within 5-10 working days of receiving the return.',
                })}</li>
              </ul>
            </div>

            <div className="bg-white border border-[#E5E0D8] p-8">
              <div className="flex items-center gap-3 mb-4">
                <Package className="w-6 h-6 text-[#4A5D23]" />
                <h2 className="text-lg font-medium text-[#1C1917]">{t({ it: 'Capi Pre-Loved', en: 'Pre-Loved Garments' })}</h2>
              </div>
              <p className="text-sm text-[#1C1917]/70 leading-relaxed">
                {t({
                  it: 'I capi Pre-Loved sono pezzi unici rigenerati e certificati: godono delle stesse condizioni di spedizione e reso dei capi nuovi.',
                  en: 'Pre-Loved garments are one-of-a-kind regenerated and certified pieces: they enjoy the same shipping and return conditions as new garments.',
                })}
              </p>
            </div>

            <div className="bg-[#4A5D23] text-white p-8">
              <div className="flex items-center gap-3 mb-4">
                <Recycle className="w-6 h-6" />
                <h2 className="text-lg font-medium">
                  {t({ it: 'Non è un reso? È il Biolosophy Value', en: "Not a return? It's Biolosophy Value" })}
                </h2>
              </div>
              <p className="text-sm text-white/80 leading-relaxed mb-4">
                {t({
                  it: 'Se vuoi restituire un capo acquistato tempo fa per ottenere uno sconto sul prossimo acquisto, non è un reso: è il nostro programma di economia circolare.',
                  en: 'If you want to bring back a garment you bought a while ago to earn a discount on your next purchase, that is not a return: it is our circular economy program.',
                })}
              </p>
              <Link to="/club" data-testid="spedizioni-club-link" className="text-white underline hover:no-underline">
                {t({ it: 'Scopri il Club Biolosophy →', en: 'Discover Club Biolosophy →' })}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
